import { API_BASE } from "@/lib/utils";

/** Load a single public event by slug (works across tenants; bootstrap is default-tenant only). */
export async function fetchPublicEventBySlug(slug) {
  const needle = String(slug || "").trim().toLowerCase();
  if (!needle) return null;
  const res = await fetch(`${API_BASE}/api/public/events/${encodeURIComponent(needle)}`, {
    cache: "no-store",
  });
  if (!res.ok) return null;
  const body = await res.json().catch(() => ({}));
  return body?.event && typeof body.event === "object" ? body.event : null;
}
